/* Three Oh Six — echter Warenkorbwert als Klaviyo-Profil-Property.
   Warum: Das Shopify-Event "Added to Cart" (Trigger des Warenkorb-Reminder-Flows)
   trägt nur den EINEN hinzugefügten Artikel — sein $value ist dessen Preis, nie die
   Warenkorbsumme. Der Flow braucht den echten Wert, um an der Versandschwelle zu
   splitten (unter der Schwelle: Gutschein-Mail, darüber: andere Mail).
   Geschrieben werden cart_total (EUR als ZAHL), cart_item_count, cart_currency,
   cart_updated_at. Consent-gated wie jeder Klaviyo-Aufruf hier: klaviyo.js lädt erst
   nach Marketing-Einwilligung. Nur für identifizierte Profile, sonst entstünde
   Profil-Müll aus anonymen Besuchern. */
(function () {
  if (window.TOSKlaviyoCartValue) return;
  window.TOSKlaviyoCartValue = true;

  /* Letzter gesendeter Stand, spart identische Calls. Wird beim Widerruf der
     Marketing-Einwilligung in consent-gate.liquid mitgelöscht. */
  var KEY = 'tos_kl_cart_value';
  var debounce = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Offizieller Klaviyo-Objekt-Stub (idempotent, identisch zu klaviyo-consent-loader
     und klaviyo-locale-sync). Sammelt Aufrufe, bis klaviyo.js geladen ist. */
  function stub() {
    !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
  }

  function getCart() {
    return fetch(root() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      ['catch'](function () {
        return null;
      });
  }

  function push(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    /* cart.js liefert Minor Units (Cent). Als Number senden, nicht als String —
       sonst vergleicht der Klaviyo-Split nicht numerisch. total_price ist der Wert
       NACH Rabatten, also genau die Größe, an der auch Shopify die Versandschwelle misst. */
    var total = Math.round(cart.total_price) / 100;
    var count = cart.item_count || 0;

    var last = null;
    try { last = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (last && last.v === total && last.c === count) return;

    stub();
    try {
      window.klaviyo.isIdentified().then(function (identified) {
        if (!identified) return;
        window.klaviyo.push(['identify', {
          cart_total: total,
          cart_item_count: count,
          cart_currency: cart.currency || 'EUR',
          cart_updated_at: new Date().toISOString(),
        }]);
        try { localStorage.setItem(KEY, JSON.stringify({ v: total, c: count })); } catch (e) {}
      })['catch'](function () {});
    } catch (e) {}
  }

  function sync() {
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(function () {
      getCart().then(push);
    }, 400);
  }

  function run() {
    sync();

    /* Zweiter Anlauf: Wer sich erst über Popup, Exit-Intent oder Fit-Quiz anmeldet,
       ist beim ersten Lauf noch nicht identifiziert. Ohne das stünde der Wert bis zum
       nächsten Seitenaufruf nicht im Profil — und genau dieser Besuch ist der, der die
       Warenkorb-Mail auslöst. */
    setTimeout(sync, 30000);

    /* Custom-Pfade (cart-upsell, cart-ghost-purge, Complete-Set) melden sich hierüber. */
    document.addEventListener('cart:refresh', sync);

    /* Theme-Pfade (Add to Cart, Menge, Entfernen) laufen über den FoxTheme-Pubsub.
       Der kommt aus theme.js und kann beim Consent-Callback noch fehlen. */
    var tries = 0;
    var wait = setInterval(function () {
      if (window.FoxTheme && window.FoxTheme.pubsub) {
        clearInterval(wait);
        window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, sync);
      } else if (++tries > 50) {
        clearInterval(wait);
      }
    }, 100);
  }

  if (window.TOSConsent) window.TOSConsent.on('marketing', run);
})();
